<template>
  <div class="rm-screen">
    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!rows.length" class="rm-empty">
      <v-icon v-if="!searchText" size="40" color="#8a817a">mdi-account-cash-outline</v-icon>
      {{ emptyTitle }}
    </div>

    <template v-else>
      <div class="rm-stats">
        <div v-for="(stat, index) in kpis" :key="stat.key" class="rm-stat" :class="{ 'rm-stat--inverse': index === 0 }">
          <span class="rm-stat__label">{{ stat.label }}{{ stat.key === "total" ? currencySuffix : "" }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="row in shownRows" :key="row.key" class="gm-user">
          <div class="gm-user__btn">
            <span class="gm-user__text">
              <span class="gm-user__name">{{ row.name }}</span>
              <span class="gm-user__meta rm-num">{{ row.meta }}</span>
              <span class="gm-user__meta rm-num">{{ row.paid }}</span>
            </span>
            <span class="cmm-money rm-num">{{ money(row.total) }}</span>
          </div>
        </li>
      </ul>
      <button v-if="hiddenCount > 0" type="button" class="rm-text-btn gm-user__more" @click="expanded = true">
        {{ $t("report_mobile.show_all_n", { n: rows.length }) }}
      </button>
    </template>
  </div>
</template>

<script>
import CompanyDesktopMultiEmployeeMealSummary from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiEmployeeMealSummary.vue";
import "@/components/report/mobile/screens/group/groupMobileUsers.scss";
import hasMultiMobile from "../../hasMultiMobile";

const PAGE_SIZE = 20;

/**
 * Mobilni "Pregled obroka po radnicima" firme "više restorana": po radniku poručeno i preuzeto, koliko je platila
 * firma, a koliko radnik (desno je ukupan iznos). Restorani i period su u zaglavlju, pretraga po imenu u lupi.
 * Računa kao ekran za računar.
 */
export default {
  name: "CompanyMobileMultiEmployeeMealSummary",
  extends: CompanyDesktopMultiEmployeeMealSummary,
  mixins: [hasMultiMobile],
  data: () => ({
    expanded: false,
  }),
  computed: {
    shownRows() {
      const rows = this.rows.map((row) => ({
        ...row,
        meta: [
          `${this.$t("number_of_orders")} ${row.orders}`,
          `${this.$t("ordered")} ${row.ordered}`,
          `${this.$t("taken")} ${row.taken}`,
        ].join(" · "),
        paid: [
          `${this.$t("company_paid")} ${this.money(row.company)}`,
          `${this.$t("employee_paid")} ${this.money(row.employee)}`,
        ].join(" · "),
      }));
      return this.expanded || this.searchText ? rows : rows.slice(0, PAGE_SIZE);
    },
    hiddenCount() {
      return this.rows.length - this.shownRows.length;
    },
  },
};
</script>
